
/** ***********************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 ************************************************************************* */

import React from 'react';
import { observable, action } from 'mobx';
import BaseDialog from './baseDialog';
import AppDialogView from '../../components/appDialog';

export default class AppDialog extends BaseDialog {
    type;

    className;

    @observable
    heading;

    @observable
    descriptionList = [];

    @observable
    actionList = [];

    @observable
    inputList = [];

    /**
     * Callback to be executed when any button is clicked
     * @type {function}
     */
    onAction;

    @action
    updateHeading = (heading) => {
        this.heading = heading;
    }

    @action
    updateDescriptionList = (descriptionList) => {
        this.descriptionList = descriptionList;
    }

    @action
    updateActionList = (actionList) => {
        this.actionList = actionList;
    }

    @action
    updateInputList = (inputList) => {
        this.inputList = inputList;
    }

    constructor({
        type,
        className,
        heading,
        descriptionList = [],
        actionList = [],
        inputList = [],
        onAction = () => {},
    }) {
        super();
        this.type = type;
        this.className = className ? ` ${className}` : '';
        this.heading = heading;
        this.descriptionList = descriptionList;
        this.actionList = actionList;
        this.inputList = inputList;
        this.onAction = onAction;
    }

    get dialogConfig() {
        return {
            render: ({ variant }) => <AppDialogView variant={variant} appDialog={this} />,
            className: `cc-app-dialog${this.className}`,
        };
    }
}
